import React from 'react';
import { motion } from 'framer-motion';
export function StatsStrip() {
  const stats = [{
    value: '+500',
    label: 'Entrenadores Confían'
  }, {
    value: '6+6',
    label: 'Tomos + Bonos'
  }, {
    value: '4.9',
    label: 'Calificación'
  }, {
    value: '🇦🇷',
    label: 'Todo el país'
  }];
  return <div className="bg-terracotta text-white py-5 md:py-8 border-b-4 border-navy-900" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 md:divide-x md:divide-white/20" data-id="element-285">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`flex flex-col items-center text-center ${index > 0 ? 'md:pl-6' : ''}`} data-id="element-286">
              <span className="font-display text-2xl md:text-5xl mb-0.5 md:mb-1 text-optic" data-id="element-287">
                {stat.value}
              </span>
              <span className="text-[10px] md:text-base font-semibold uppercase tracking-wider opacity-90" data-id="element-288">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}